import React, { Fragment, useEffect, useState } from 'react';
import {
  Typography,
  Button,
  Form,
  message,
  Input,
  Select,
  DatePicker,
  ConfigProvider,
  Checkbox,
  Col,
  Row,
  Tooltip,
  Modal,
  Alert,
  Radio,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
// import 'moment/locale/ja';
import locale from 'antd/es/locale/ja_JP';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Axios from 'axios';
import {
  SEASON_FIELDS,
  isFieldRequired,
  collectMissingLabels,
  SERVER_FIELD_LABELS,
} from './seasonFields';

dayjs.extend(utc);
// import 'dayjs/locale/ja';
// import type { DatePickerProps } from 'antd';
//90101 = [0,0,0,0,0]
//90301 = []
//90501 = [0,0]
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

// レポート表紙に表示できる所属レイヤーの選択肢（所属1〜7）。
// 範囲を変更する場合はこの配列 1 箇所のみ修正すればよい。
const DISPLAY_DEPARTMENT_OPTIONS = [1, 2, 3, 4, 5, 6, 7];
// 設問セット割り当て対象のサーベイコード（設問マッチング対象サーベイ）
const QSET_TARGET_SURVEY_CODES = ['20110', '20210', '40010', '60020'];
// 本人用・協力者用の2セットが必要なサーベイコード
const QSET_NEEDS_TWO_CODES = ['40010', '60020'];
// sub_type の表示ラベル（4=本人用 / 5=協力者用）
const QSET_SUB_TYPE_LABEL = { 4: '本人用', 5: '協力者用' };
// let checkTag = <></>;

// 登録失敗時のメッセージ。サーバーが未入力項目を返してきたら項目名を出す。
const seasonErrorMessage = (error) => {
  const data = (error && error.response && error.response.data) || {};
  const fields = Array.isArray(data.invalidFields) ? data.invalidFields : [];
  const labels = [...new Set(fields.map((f) => SERVER_FIELD_LABELS[f] || f))];
  return labels.length
    ? `シーズン登録に失敗しました。未入力の項目：${labels.join(' / ')}`
    : 'シーズン登録に失敗しました。';
};

const MakeSeasonPage = (props) => {
  // 日程類は初期値を入れない。「今日」を自動で入れると未設定と区別できず、
  // 回答日程が未設定のまま登録されても気づけない（回答終了日は採点分岐に使われる）。
  const [value, setValue] = useState({});
  const [mode, setMode] = useState('new');
  const [groupInfo, setGroupInfo] = useState([]);
  const [surveyInfo, setSurveyInfo] = useState([]);
  const [sendTicket, setSendTicket] = useState(false); //配布チケット有無を記録（初期値：配布なし）
  const [questionSetInfo, setQuestionSetInfo] = useState([]); //全ての設問セット
  const [assignedQSets, setAssignedQSets] = useState([]); //割り当て済み設問セット（DB保存済み）
  const [selectedQSetIds, setSelectedQSetIds] = useState([]); //新たに割り当てる設問セットID（登録時に反映）
  // const [coursePartViewString, setCoursePartViewString] = useState('');
  const sInfo = props.location.state;
  const { user } = props;
  // console.log({ sInfo });
  // let coursePartViewString = '';

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        // console.log(sInfo._id);
        if (sInfo._id) {
          //シーズン編集の場合
          const [group, survey, qSet, exToken] = await Promise.all([
            Axios.get('/api/group/'),
            Axios.get('/api/survey/'),
            Axios.get('/api/questionSet/'), //全ての設問セット取得
            Axios.get(`/api/surveyToken/existToken/${sInfo._id}`), //このシーズンで配布されたチケットを１枚
          ]);
          if (exToken.data.tokenInfo) {
            //配布されたチケットが１枚でもある場合
            setSendTicket(true);
          }
          // console.log({ exToken });
          // console.log(group.data.groups);
          // console.log(survey.data.survey);
          if (group.data.success && survey.data.success) {
            setGroupInfo(group.data.groups);
            setSurveyInfo(survey.data.survey);
            setQuestionSetInfo(qSet.data.questionSet || []);
          } else {
            throw new Error('グループ取得に失敗しました。');
          }
        } else {
          //新規シーズンの場合
          const [group, survey, qSet] = await Promise.all([
            Axios.get('/api/group/'),
            Axios.get('/api/survey/'),
            Axios.get('/api/questionSet/'), //全ての設問セット取得
          ]);
          // console.log(group.data.groups);
          // console.log(survey.data.survey);
          if (group.data.success && survey.data.success) {
            setGroupInfo(group.data.groups);
            setSurveyInfo(survey.data.survey);
            setQuestionSetInfo(qSet.data.questionSet || []);
          } else {
            throw new Error('グループ取得に失敗しました。');
          }
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!user.userData) return null;
    readDB();
    if (sInfo._id) {
      // console.log({ sInfo });
      // const t = Axios.get(
      //   `/api/surveyToken/existToken/${sInfo.survey_season_id}`
      // );
      // console.log({ t });
      setMode('edit');
      setAssignedQSets(sInfo.question_set || []); //割り当て済み設問セット
      setValue({
        _id: sInfo._id,
        season_name: sInfo.season_name,
        group_code: sInfo.group_code,
        group_id: sInfo.group_id,
        season_description: sInfo.season_description,
        t_name: sInfo.t_name,
        survey_code: sInfo.survey_code,
        survey_id: sInfo.survey_id,
        survey_start_date: sInfo.survey_start_date,
        survey_end_date: sInfo.survey_end_date,
        training_start_date: sInfo.training_start_date,
        training_end_date: sInfo.training_end_date,
        output_360_type: sInfo.output_360_type,
        output_360_date: sInfo.output_360_date,
        e3_option: sInfo.e3_option,
        survey_name: sInfo.survey_name,
        name_360: sInfo.name_360,
        course_part_view: sInfo.course_part_view,
        course_part_view_string: arrayToString(sInfo.course_part_view),
        display_department: sInfo.display_department || [],
        // 会社名の表示元（未設定の旧シーズンは 'group_name' 扱い）
        company_name_source: sInfo.company_name_source || 'group_name',
        due_datetime: sInfo.due_datetime
          ? dayjs.utc(sInfo.due_datetime).format('YYYY-MM-DD HH:mm:ss')
          : null,
        extended_due_datetime: sInfo.extended_due_datetime
          ? dayjs.utc(sInfo.extended_due_datetime).format('YYYY-MM-DD HH:mm:ss')
          : null,
      });
    } else {
      setValue({ ...value, active: true, company_name_source: 'group_name' });
    }
  }, [user]);

  const arrayToString = (arr) => {
    let str = '';
    for (let i = 0; i < arr.length; i++) {
      str = str + String(arr[i]);
    }
    return str;
  };

  const onChangeSeasonName = (e) => {
    setValue({ ...value, season_name: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeSeasonDescription = (e) => {
    setValue({ ...value, season_description: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeTName = (e) => {
    setValue({ ...value, t_name: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeName360 = (e) => {
    setValue({ ...value, name_360: e.currentTarget.value });
    // console.log(value);
  };
  // 回答期限の変更ハンドラ（DatePicker showTime）
  const onChangeDueDatetime = (date, dateString) => {
    setValue({ ...value, due_datetime: dateString || null });
  };
  // 回答延長期限の変更ハンドラ（DatePicker showTime）
  const onChangeExtendedDueDatetime = (date, dateString) => {
    setValue({ ...value, extended_due_datetime: dateString || null });
  };
  const onChangeGroup = (v) => {
    const selected = groupInfo.find((item) => item.group_code === v);
    setValue({
      ...value,
      group_code: v,
      group_id: selected._id,
      // 系列会社なしのグループでは「会社名の表示元」はグループ名に固定する
      ...(selected.has_affiliates
        ? {}
        : { company_name_source: 'group_name' }),
    });
    // console.log(value);
  };
  const onChangeSurvey = (v) => {
    //サーベイ変更時は選択中の設問セットをクリア（サーベイ不一致のセット混入防止）
    setSelectedQSetIds([]);
    // サーベイに紐づく項目（サーベイによって画面に出たり消えたりする項目）は
    // サーベイを変えたら必ずクリアする。企業名のように常時表示で
    // サーベイと独立している項目は保持する。
    //
    // 公開選択も「サーベイに紐づく項目」として毎回クリアする。残すと
    // 「本当は変えるべきだったのに気づかず登録」が起こりうるが、クリアして
    // おけば登録前チェック（公開選択は条件付き必須）で必ず止まるため、
    // 未設定のまま登録されることはない。
    setValue({
      ...value,
      survey_code: v,
      survey_id: surveyInfo.find((item) => item.survey_code === v)._id,
      survey_name: surveyInfo.find((item) => item.survey_code === v)
        .survey_name,
      output_360_type: null,
      output_360_date: null,
      e3_option: null,
      course_part_view: [],
      course_part_view_string: undefined,
    });
    // checkTag = <></>;
    // } else if (v === '90101') {
    //   setValue({
    //     ...value,
    //     survey_code: v,
    //     survey_id: surveyInfo.find((item) => item.survey_code === v)._id,
    //     survey_name: surveyInfo.find((item) => item.survey_code === v)
    //       .survey_name,
    //     output_360_type: null,
    //     output_360_date: today_ymd(),
    //     e3_option: null,
    //     course_part_view: [],
    //   });
    // } else if (v === '90501') {
    //   setValue({
    //     ...value,
    //     survey_code: v,
    //     survey_id: surveyInfo.find((item) => item.survey_code === v)._id,
    //     survey_name: surveyInfo.find((item) => item.survey_code === v)
    //       .survey_name,
    //     output_360_type: null,
    //     output_360_date: today_ymd(),
    //     e3_option: null,
    //     course_part_view: [],
    //   });
    // } else {
    //   setValue({
    //     ...value,
    //     survey_code: v,
    //     survey_id: surveyInfo.find((item) => item.survey_code === v)._id,
    //     survey_name: surveyInfo.find((item) => item.survey_code === v)
    //       .survey_name,
    //     output_360_type: null,
    //     output_360_date: today_ymd(),
    //     e3_option: null,
    //     course_part_view: [],
    //   });
    // }
    // console.log(value);
  };

  const onChangeCheck = (e) => {
    const valueArr = e.currentTarget.value.split('');
    let numArr = [];
    for (let i = 0; i < valueArr.length; i++) {
      numArr.push(Number(valueArr[i]));
    }
    setValue({
      ...value,
      course_part_view: numArr,
      course_part_view_string: e.currentTarget.value,
    });
  };

  const onChangeOpenPdf = (v) => {
    // setOpenPdf360(v);
    setValue({
      ...value,
      output_360_type: v,
      // output_360_date: null,
    });
    // console.log(value);
  };

  const onChangeOption40010 = (v) => {
    // setOpenPdf360(v);
    setValue({
      ...value,
      e3_option: v,
    });
    // console.log(value);
  };
  //研修日程をStart→Endの形に変更 20221215
  const onChangeTrainingPriod = (date, dateString) => {
    setValue({
      ...value,
      training_start_date: (dateString && dateString[0]) || null, // 日付のみ (YYYY-MM-DD)
      training_end_date: (dateString && dateString[1]) || null, // 時間情報なし
    });
  };
  //サーベイ回答日程をStart→Endの形に変更 20221215
  const onChangeSurveyPriod = (date, dateString) => {
    setValue({
      ...value,
      survey_start_date: (dateString && dateString[0]) || null, // 日付のみ (YYYY-MM-DD)
      survey_end_date: (dateString && dateString[1]) || null, // 時間情報なし
    });
  };
  // const onChangeEndDate = (date, dateString) => {
  //   // console.log(date, dateString);
  //   setValue({ ...value, survey_end_date: dateString + ' 23:59:59' });
  // };
  const onChangeopenPdf360Date = (date, dateString) => {
    setValue({
      ...value,
      output_360_date: dateString ? dateString + ' 00:00:00' : null,
    });
  };

  // 定義表(seasonFields.js)から「必須／任意」バッジを描く。
  // 表を直せば画面表示と登録前チェックが同時に変わる（手書きの「（必須）」は廃止）。
  const fieldBadge = (fieldKey) => {
    const field = SEASON_FIELDS.find((f) => f.key === fieldKey);
    if (!field) return null;
    const required = isFieldRequired(field, value);
    return (
      <Fragment>
        <Text
          style={{
            marginLeft: 8,
            fontSize: 12,
            color: required ? '#cf1322' : '#8c8c8c',
          }}
        >
          {required ? '必須' : '任意'}
        </Text>
        {!required && field.note ? (
          <Text type="secondary" style={{ fontSize: 12, marginLeft: 4 }}>
            （{field.note}）
          </Text>
        ) : null}
      </Fragment>
    );
  };

  const onSubmit = async () => {
    // 登録前チェック。足りない項目をまとめて画面に出す（新規・編集の両方）。
    // サーバーの required だけに頼っていたころは、何が足りないのか画面に出ず
    // 「シーズン登録に失敗しました。」しか分からなかった。
    // 編集(PATCH)は findByIdAndUpdate のため既定ではスキーマ検証が走らない。
    // 編集経路を守れるのはこのチェックだけなので、新規・編集の両方で必ず通す。
    const missing = collectMissingLabels(value);
    if (missing.length > 0) {
      message.error({
        content: `未入力の項目があります：${missing.join(' / ')}`,
        key: 'submit',
        duration: 4,
      });
      return;
    }
    try {
      let res = {};
      //今回新たに割り当てる設問セット（フルドキュメント）
      const pickedQSets = questionSetInfo.filter((qs) =>
        selectedQSetIds.includes(qs._id)
      );
      if (mode === 'edit') {
        res = await Axios.patch('/api/surveySeason', value);
        if (res.data.success && pickedQSets.length > 0) {
          //シーズン本体の保存後、追加分のみ既存の割り当てAPIで反映
          const newlyAssigned = [];
          for (const qs of pickedQSets) {
            const ar = await Axios.patch('/api/questionSet/assignSet', {
              groupId: value.group_id,
              seasonId: value._id,
              questionSetInfo: qs,
            });
            if (!ar.data.success) {
              //成功分は割り当て済みへ移し、再試行時の二重登録を防ぐ
              setAssignedQSets([...assignedQSets, ...newlyAssigned]);
              setSelectedQSetIds(
                selectedQSetIds.filter(
                  (id) => !newlyAssigned.some((n) => n._id === id)
                )
              );
              throw new Error('設問セット割り当てに失敗しました。');
            }
            newlyAssigned.push(qs);
          }
        }
      } else {
        //新規作成時は question_set を含めて一括登録（サーバは body を丸ごと保存）
        const body =
          pickedQSets.length > 0
            ? { ...value, question_set: pickedQSets }
            : value;
        res = await Axios.post('/api/surveySeason', body);
      }
      // console.log({ res });
      if (res.data.success) {
        message.success({
          content: 'シーズン登録完了！',
          key: 'submit',
          duration: 2,
        });
        setTimeout(() => {
          props.history.push('/seasonlist');
        }, 1000);
      } else {
        throw new Error('シーズン登録に失敗しました。');
      }
    } catch (error) {
      message.error({
        content: seasonErrorMessage(error),
        key: 'submit',
        duration: 4,
      });
      console.log({ error });
    }
  };

  const onCancel = async () => {
    props.history.push('/seasonlist');
  };

  const onSubmitCopy = async () => {
    if (mode !== 'edit') return;
    const missing = collectMissingLabels(value);
    if (missing.length > 0) {
      message.error({
        content: `未入力の項目があるため複製できません：${missing.join(' / ')}`,
        key: 'submit',
        duration: 4,
      });
      return;
    }
    try {
      // _idを除外して新規レコードとして保存
      const { _id, ...copyValue } = value;
      //割り当て済み + 選択中の設問セットも複製先へ承継する
      const pickedQSets = questionSetInfo.filter((qs) =>
        selectedQSetIds.includes(qs._id)
      );
      const copyQSets = [...assignedQSets, ...pickedQSets];
      if (copyQSets.length > 0) copyValue.question_set = copyQSets;
      const res = await Axios.post('/api/surveySeason', copyValue);

      if (res.data.success) {
        message.success({
          content: 'シーズン複製完了！',
          key: 'submit',
          duration: 2,
        });
        setTimeout(() => {
          props.history.push('/seasonlist');
        }, 1000);
      } else {
        throw new Error('シーズン複製に失敗しました。');
      }
    } catch (error) {
      message.error({
        content: seasonErrorMessage(error).replace('登録', '複製'),
        key: 'submit',
        duration: 4,
      });
      console.log({ error });
    }
  };

  //===========================================
  // シーズン一括削除 (C5)
  // 計画書 Ph.4 — シーズン編集画面からのみ削除可能。role 9 限定。
  // シーズン名 echo + バックアップメール送信成功後にカスケード削除
  //===========================================
  const showSeasonDeleteConfirm = () => {
    if (mode !== 'edit' || !sInfo || !sInfo._id) return;
    const seasonName = (sInfo.season_name || '').trim();
    let inputEcho = '';

    Modal.confirm({
      title: 'シーズン全体を削除します',
      width: 620,
      icon: null,
      content: (
        <div>
          <Alert
            type="error"
            showIcon
            message="この操作は取り消せません"
            description={
              <div>
                <p>
                  シーズン <b>{seasonName}</b> を、関連するチーム・
                  SurveyToken・回答データ・PDF レポートすべて含めて削除します。
                </p>
                <p>
                  対象本人・組織・会社の PDF レポートは ReportDoc も S3
                  ファイル本体もすべて削除されます。TrialCampaign が
                  本シーズンを参照している場合は削除を拒否します
                  （先にキャンペーンから除外してください）。
                </p>
                <p>
                  本シーズンを参照する未配信(送信前)の予約メールは
                  シーズンと一緒に削除されます。配信完了・エラーの
                  レコードは履歴として残ります。
                </p>
                <p>
                  回答済データが存在する場合、削除前に{' '}
                  <b>retech@re-current.co.jp</b> /{' '}
                  <b>admin365@re-current.co.jp</b> に JSON
                  原文がバックアップメールとして送信されます。
                </p>
                <p>
                  続行するには、シーズン名「<b>{seasonName}</b>
                  」をそのまま入力してください。
                </p>
              </div>
            }
            style={{ marginBottom: 12 }}
          />
          <Input
            placeholder="シーズン名"
            onChange={(ev) => {
              inputEcho = ev.target.value;
            }}
            autoFocus
          />
        </div>
      ),
      okText: '削除実行',
      okButtonProps: { danger: true },
      cancelText: 'キャンセル',
      async onOk() {
        if (inputEcho.trim() !== seasonName) {
          message.error({
            content: 'シーズン名が一致しません',
            key: 'season-del',
            duration: 2,
          });
          return Promise.reject();
        }
        const res = await seasonDeleteHandler();
        if (res && res.data && res.data.success) {
          const deletedMail = res.data.deleted_mail_count || 0;
          const retainedMail = res.data.retained_mail_count || 0;
          const noteParts = [];
          if (deletedMail > 0) {
            noteParts.push(`未配信予約メール ${deletedMail} 件も削除`);
          }
          if (retainedMail > 0) {
            noteParts.push(`配信履歴 ${retainedMail} 件は保持`);
          }
          const note = noteParts.length ? `（${noteParts.join('、')}）` : '';
          message.success({
            content: `シーズンを削除しました${note}`,
            key: 'season-del',
            duration: 4,
          });
          setTimeout(() => {
            props.history.push('/seasonlist');
          }, 800);
        } else {
          // サーバ側エラー（TrialCampaign 参照ガード / バックアップメール失敗 等）
          // 失敗時はモーダルを閉じずに、ユーザーが対応後に再試行できるようにする
          message.error({
            content:
              (res && res.data && res.data.error) ||
              'シーズン削除に失敗しました',
            key: 'season-del',
            duration: 6,
          });
          return Promise.reject();
        }
      },
      onCancel() {
        // 通常キャンセル時はメッセージ不要
      },
    });
  };

  // C5 API 呼び出し
  const seasonDeleteHandler = async () => {
    try {
      const info = {
        confirm: 'YES_DELETE_SEASON',
        seasonNameEcho: sInfo.season_name,
        executorToken: localStorage.getItem('w_auth'),
      };
      const res = await Axios.post(
        `/api/surveySeason/${sInfo._id}/delete`,
        info
      );
      return res;
    } catch (error) {
      console.log(error);
      return error.response || null;
    }
  };

  // 選択中のグループ（系列会社あり判定に使う。旧データは has_affiliates 未定義＝なし）
  const selectedGroup = groupInfo.find(
    (g) => g.group_code === value.group_code
  );

  return (
    <ConfigProvider locale={locale}>
      <Fragment>
        <div style={{ maxWidth: '600px', margin: '2rem auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <Title level={2}>サーベイ・シーズン作成</Title>
          </div>
          <Form onSubmit={onSubmit}>
            <br />
            <div>
              <Text strong>■ シーズン名：例）2022 人事評価力診断 1回</Text>
              {fieldBadge('season_name')}
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              ></div>
            </div>
            <Input
              placeholder="シーズン名"
              name="season_name"
              allowClear
              onChange={onChangeSeasonName}
              value={value['season_name']}
            />
            <br />
            <br />
            <div>
              <Text strong>■ シーズン説明：全ての情報を網羅</Text>
              {fieldBadge('season_description')}
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              ></div>
            </div>
            <Input
              placeholder="シーズン説明"
              name="season_description"
              allowClear
              onChange={onChangeSeasonDescription}
              value={value['season_description']}
            />
            <br />
            <br />
            <div>
              <Text strong>■ 研修名：例）新任課長代理研修</Text>
              {fieldBadge('t_name')}
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              ></div>
            </div>
            <Input
              placeholder="研修名"
              name="t_name"
              allowClear
              onChange={onChangeTName}
              value={value['t_name']}
            />
            <br />
            <br />
            <div>
              <Text strong>■ 企業選択</Text>
              {fieldBadge('group_code')}
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              ></div>
            </div>
            <Select
              showSearch
              style={{
                width: 600,
              }}
              placeholder="企業選択"
              optionFilterProp="children"
              onChange={onChangeGroup}
              value={value['group_code']}
              disabled={mode === 'edit'}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {groupInfo.map((element) => {
                // console.log({ element });
                return (
                  <Option value={element.group_code} key={element._id}>
                    {element.group_name}
                  </Option>
                );
              })}
            </Select>
            <br />
            <br />
            <div>
              <Text strong>■ サーベイ選択</Text>
              {fieldBadge('survey_code')}
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              ></div>
            </div>
            <Select
              showSearch
              style={{
                width: 600,
              }}
              placeholder="サーベイ選択"
              optionFilterProp="children"
              onChange={onChangeSurvey}
              value={value['survey_code']}
              disabled={sendTicket || assignedQSets.length > 0}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {surveyInfo.map((element) => {
                // console.log({ element });
                return (
                  <Option value={element.survey_code} key={element._id}>
                    {element.survey_name}
                  </Option>
                );
              })}
            </Select>
            {QSET_TARGET_SURVEY_CODES.includes(value.survey_code) && (
              <Fragment>
                <br />
                <br />
                <div>
                  <Text strong>■ 設問セット割り当て</Text>
                  {fieldBadge('question_set')}
                  {QSET_NEEDS_TWO_CODES.includes(value.survey_code) && (
                    <Text
                      type="secondary"
                      style={{ marginLeft: 'var(--space-2)' }}
                    >
                      ※ 本人用・協力者用の2セットが必要です
                    </Text>
                  )}
                </div>
                {assignedQSets.length > 0 && (
                  <div style={{ margin: 'var(--space-2) 0' }}>
                    {assignedQSets.map((qs) => (
                      <div key={qs._id}>
                        <Text
                          style={{
                            fontSize: 'var(--text-sm)',
                            color: 'var(--blue-active)',
                          }}
                        >
                          ・{`${qs.set_name}(${qs.set_description})`}
                          {QSET_SUB_TYPE_LABEL[qs.sub_type]
                            ? ` → ${QSET_SUB_TYPE_LABEL[qs.sub_type]}`
                            : ''}
                        </Text>
                      </div>
                    ))}
                    <Text type="secondary">
                      ※ 設問セット割り当て済みのため、サーベイは変更できません
                    </Text>
                  </div>
                )}
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: 600, marginTop: 'var(--space-2)' }}
                  placeholder="追加する設問セットを選択（登録時に割り当て）"
                  optionFilterProp="children"
                  value={selectedQSetIds}
                  onChange={(ids) => setSelectedQSetIds(ids)}
                >
                  {questionSetInfo
                    .filter(
                      (qs) =>
                        qs.survey_code === value.survey_code &&
                        !qs.disabled &&
                        !assignedQSets.some((a) => a._id === qs._id)
                    )
                    .map((qs) => (
                      <Option value={qs._id} key={qs._id}>
                        {`${qs.set_name}(${qs.set_description})`}
                      </Option>
                    ))}
                </Select>
              </Fragment>
            )}
            {value.survey_code === '90101' && (
              <Fragment>
                <br />
                <br />
                <Text strong>■ 表示領域選択記号（例：0111）</Text>
                {fieldBadge('course_part_view_string')}
                <br />
                <br />
                <Input
                  placeholder="コース構成"
                  name="course_part_view_string"
                  allowClear
                  onChange={onChangeCheck}
                  value={value['course_part_view_string']}
                />
              </Fragment>
            )}
            {(value.survey_code === '90501' ||
              value.survey_code === '90502') && (
              <Fragment>
                <br />
                <br />
                <Text strong>■ 表示領域選択記号（例：11）</Text>
                {fieldBadge('course_part_view_string')}
                <br />
                <br />
                <Input
                  placeholder="コース構成"
                  name="course_part_view_string"
                  allowClear
                  onChange={onChangeCheck}
                  value={value['course_part_view_string']}
                />
              </Fragment>
            )}
            <br />
            <br />
            {value.survey_code && (
              <Fragment>
                <Text strong>
                  ■ 表示所属（レポート表紙に表示する所属レイヤー）
                </Text>
                {fieldBadge('display_department')}
                <br />
                <br />
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: 400 }}
                  placeholder="表示する所属を選択（未選択=既定：所属1）"
                  value={value.display_department || []}
                  onChange={(vals) =>
                    setValue({
                      ...value,
                      display_department: [...vals].sort((a, b) => a - b),
                    })
                  }
                >
                  {DISPLAY_DEPARTMENT_OPTIONS.map((n) => (
                    <Option value={n} key={n}>{`所属${n}`}</Option>
                  ))}
                </Select>
                <br />
                <br />
                {selectedGroup && selectedGroup.has_affiliates && (
                  <Fragment>
                    <Text strong>■ 会社名の表示元</Text>
                    {fieldBadge('company_name_source')}
                    <br />
                    <br />
                    <Radio.Group
                      value={value.company_name_source || 'group_name'}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          company_name_source: e.target.value,
                        })
                      }
                    >
                      <Radio value="group_name">
                        グループ名（{selectedGroup.group_name}）
                      </Radio>
                      <Radio value="company">
                        系列会社名（ユーザーの会社名）
                      </Radio>
                    </Radio.Group>
                    <div style={{ marginTop: 'var(--space-1)' }}>
                      <Text
                        type="secondary"
                        style={{ fontSize: 'var(--text-sm)' }}
                      >
                        レポートの会社名欄に印字する名称を選びます。
                      </Text>
                    </div>
                    <br />
                  </Fragment>
                )}
              </Fragment>
            )}
            {value.survey_code === '30010' && (
              <Fragment>
                <div>
                  <Text strong>■ オプション選択</Text>
                  {fieldBadge('e3_option')}
                </div>
                <br />
                <Select
                  showSearch
                  style={{
                    width: 400,
                  }}
                  placeholder="オプション選択"
                  optionFilterProp="children"
                  onChange={onChangeOption40010}
                  value={value.e3_option}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value={0} key={0}>
                    組織診断のみ
                  </Option>
                  <Option value={1} key={1}>
                    パーソナル診断のみ
                  </Option>
                  <Option value={2} key={2}>
                    組織診断＋パーソナル診断
                  </Option>
                  )
                </Select>
                <br />
                <br />
              </Fragment>
            )}
            {value.survey_code === '30010' &&
              (value.e3_option === 1 || value.e3_option === 2) && (
                <Fragment>
                  <div>
                    <Text strong>■ 公開選択（結果の表示方法）</Text>
                    {fieldBadge('output_360_type')}
                  </div>
                  <br />
                  <Select
                    showSearch
                    style={{
                      width: 400,
                    }}
                    placeholder="公開選択"
                    optionFilterProp="children"
                    onChange={onChangeOpenPdf}
                    value={value.output_360_type}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value={0} key={0}>
                      非公開（管理者のみ公開）
                    </Option>
                    <Option value={1} key={1}>
                      受検直後公開
                    </Option>
                    <Option value={2} key={2}>
                      日付指定公開
                    </Option>
                    )
                  </Select>
                  <br />
                  <br />
                </Fragment>
              )}
            {(value.survey_code === '40010' ||
              value.survey_code === '60020') && (
              <Fragment>
                <div>
                  <Text strong>■ 公開選択（結果の表示方法）</Text>
                  {fieldBadge('output_360_type')}
                </div>
                <br />
                <Select
                  showSearch
                  style={{
                    width: 400,
                  }}
                  placeholder="公開選択"
                  optionFilterProp="children"
                  onChange={onChangeOpenPdf}
                  value={value.output_360_type}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value={0} key={0}>
                    非公開（管理者のみ公開）
                  </Option>
                  <Option value={1} key={1}>
                    受検直後公開
                  </Option>
                  <Option value={2} key={2}>
                    日付指定公開
                  </Option>
                  )
                </Select>
                <br />
                <br />
              </Fragment>
            )}
            {(value.survey_code === '50020' ||
              value.survey_code === '50030' ||
              value.survey_code === '50040' ||
              value.survey_code === '10010' ||
              value.survey_code === '50010') && (
              <Fragment>
                <div>
                  <Text strong>■ 公開選択（結果の表示方法）</Text>
                  {fieldBadge('output_360_type')}
                </div>
                <br />
                <Select
                  showSearch
                  style={{
                    width: 400,
                  }}
                  placeholder="公開選択"
                  optionFilterProp="children"
                  onChange={onChangeOpenPdf}
                  value={value.output_360_type}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value={0} key={0}>
                    非公開（管理者のみ公開）
                  </Option>
                  <Option value={1} key={1}>
                    受検直後公開
                  </Option>
                  <Option value={2} key={2}>
                    日付指定公開
                  </Option>
                  )
                </Select>
                <br />
                <br />
              </Fragment>
            )}
            {(value.survey_code === '40010' ||
              value.survey_code === '60020' ||
              value.survey_code === '50030' ||
              value.survey_code === '50040' ||
              value.survey_code === '50020' ||
              value.survey_code === '10010' ||
              value.survey_code === '50010' ||
              value.survey_code === '30010') &&
              value.output_360_type === 2 && (
                <Fragment>
                  <div>
                    <Text strong>■ 公開日</Text>
                    {fieldBadge('output_360_date')}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    ></div>
                  </div>
                  <DatePicker
                    onChange={onChangeopenPdf360Date}
                    locale={locale}
                    value={
                      value.output_360_date
                        ? dayjs(value.output_360_date)
                        : null
                    }
                  />
                  →０時から公開
                  <br />
                  <br />
                </Fragment>
              )}
            {/* 診断表示名・回答期限入力（全サーベイ共通・サーベイ選択後に表示） */}
            {value.survey_code && (
              <Fragment>
                <div>
                  <Text strong>■ 診断表示名：例）●●診断</Text>
                  {fieldBadge('name_360')}
                  <Tooltip
                    title={
                      <span>
                        メールテンプレートで <b>{'{$survey_display_name$}'}</b>{' '}
                        として利用できます（例：●●診断）
                      </span>
                    }
                  >
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: 'var(--blue-active)' }}
                    />
                  </Tooltip>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  ></div>
                </div>
                <Input
                  placeholder="●●診断"
                  name="name_360"
                  allowClear
                  onChange={onChangeName360}
                  value={value['name_360']}
                />
                <br />
                <br />
                <div>
                  <Text strong>
                    ■ サーベイ回答日程（サーベイ・チケット実表示期間）
                  </Text>
                  {fieldBadge('survey_period')}
                  <Tooltip
                    title={
                      <span>
                        開始日をメールテンプレートで{' '}
                        <b>{'{$first_delivery_date$}'}</b>{' '}
                        として利用できます（例：4月21日(火)）
                      </span>
                    }
                  >
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: 'var(--blue-active)' }}
                    />
                  </Tooltip>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  ></div>
                </div>
                <RangePicker
                  onChange={onChangeSurveyPriod}
                  locale={locale}
                  placeholder={['開始日', '終了日']}
                  value={
                    value.survey_start_date && value.survey_end_date
                      ? [
                          dayjs(value.survey_start_date),
                          dayjs(value.survey_end_date),
                        ]
                      : null
                  }
                />
                <br />
                <br />
                <div>
                  <Text strong>■ 回答期限（表示のみ）</Text>
                  {fieldBadge('due_datetime')}
                  <Tooltip
                    title={
                      <span>
                        メールテンプレートで <b>{'{$due_datetime$}'}</b>{' '}
                        として利用できます（例：2026年4月21日（火）18:00）
                      </span>
                    }
                  >
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: 'var(--blue-active)' }}
                    />
                  </Tooltip>
                </div>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="回答期限を選択"
                  locale={locale}
                  value={value.due_datetime ? dayjs(value.due_datetime) : null}
                  onChange={onChangeDueDatetime}
                />
                <br />
                <br />
                <div>
                  <Text strong>■ 回答延長期限（表示のみ）</Text>
                  {fieldBadge('extended_due_datetime')}
                  <Tooltip
                    title={
                      <span>
                        メールテンプレートで{' '}
                        <b>{'{$extended_due_datetime$}'}</b>{' '}
                        として利用できます（例：2026年4月21日（火）18:00）
                      </span>
                    }
                  >
                    <QuestionCircleOutlined
                      style={{ marginLeft: 8, color: 'var(--blue-active)' }}
                    />
                  </Tooltip>
                </div>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="回答延長期限を選択"
                  locale={locale}
                  value={
                    value.extended_due_datetime
                      ? dayjs(value.extended_due_datetime)
                      : null
                  }
                  onChange={onChangeExtendedDueDatetime}
                />
                <br />
                <br />
              </Fragment>
            )}
            <div>
              <Text strong>■ 研修日程</Text>
              {fieldBadge('training_period')}
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              ></div>
            </div>
            <RangePicker
              onChange={onChangeTrainingPriod}
              locale={locale}
              placeholder={['開始日', '終了日']}
              value={
                value.training_start_date && value.training_end_date
                  ? [
                      dayjs(value.training_start_date),
                      dayjs(value.training_end_date),
                    ]
                  : null
              }
            />
            <br />
            <br />
            <Button
              type="primary"
              size="large"
              onClick={onSubmit}
              disabled={false}
            >
              登録
            </Button>
            　
            <Button size="large" onClick={onCancel} disabled={false}>
              キャンセル
            </Button>
            　
            <Button
              danger
              size="large"
              onClick={onSubmitCopy}
              disabled={mode !== 'edit'}
            >
              複製
            </Button>
            {mode === 'edit' && user.userData && user.userData.role === 9 && (
              <>
                　
                <Button danger size="large" onClick={showSeasonDeleteConfirm}>
                  シーズン削除
                </Button>
              </>
            )}
          </Form>
        </div>
      </Fragment>
    </ConfigProvider>
  );
};

export default MakeSeasonPage;
